<template>
  <div class="flex flex-col h-screen relative overflow-hidden">
    <!-- Mobile Background -->
    <div class="fixed inset-0 z-0 w-full h-full sm:hidden" :style="{
        backgroundImage: 'url(/login.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }"
    ></div>

    <!-- Desktop Background -->
    <div class="fixed inset-0 z-0 w-full h-full hidden sm:block" :style="{
        backgroundImage: 'url(/loginDesktop.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed'
      }"
    ></div>

    <div class="flex-1 flex flex-col justify-end pb-8 px-4 sm:justify-center sm:pb-0">
      <div class="relative z-10 w-full max-w-md mx-auto p-8 rounded-3xl overflow-hidden">
        <div class="text-center mb-8">
          <h1 class="text-2xl font-bold text-white mb-2 font-opensans" style="text-shadow: 0 4px 8px rgba(0, 0, 0, 0.6), 0 2px 4px rgba(0, 0, 0, 0.4);">Welcome to Travley</h1>
          <p class="text-white/80 font-opensans" style="text-shadow: 0 2px 6px rgba(0, 0, 0, 0.5), 0 1px 3px rgba(0, 0, 0, 0.3);">Sign in to continue</p>
        </div>

        <!-- Google Sign-in Button with Custom Visual Wrapper -->
        <div class="flex justify-center mb-1 w-full">
          <div class="w-full sm:w-4/5 md:w-3/4 lg:w-2/3 custom-google-button-wrapper">
            <!-- Custom Visual Overlay -->
            <div class="custom-google-button-overlay">
              <div class="custom-button-content">
                <svg class="google-logo" width="20" height="20" viewBox="0 0 24 24">
                  <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                <span class="button-text">Sign in with Google</span>
              </div>
            </div>
            <!-- Hidden Medium Google Button for Functionality -->
            <div id="googleSignInButton" class="hidden-google-button"></div>
          </div>
        </div>

        <!-- Spotify Sign-in Button -->
        <div class="flex justify-center w-full mt-4">
          <button class="flex items-center justify-center bg-[#1DB954] text-white px-8 py-2 rounded-full shadow-lg hover:shadow-xl transition-shadow w-full sm:w-4/5 md:w-2/ lg:w-2/3" @click="handleSpotifySignIn">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" viewBox="0 0 24 24">
              <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.48.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" fill="white"/>
            </svg>
            Sign in with Spotify
          </button>
        </div>

        <!-- Divider -->
        <div class="flex items-center my-6 w-full sm:w-4/5 md:w-3/4 lg:w-2/3 mx-auto">
          <div class="flex-1 h-px bg-white/20"></div>
          <span class="px-4 text-white/60 text-sm">or</span>
          <div class="flex-1 h-px bg-white/20"></div>
        </div>

        <!-- Email Authentication -->
        <div class="flex justify-center w-full">
          <div class="w-full sm:w-4/5 md:w-3/4 lg:w-2/3">
            <EmailAuth />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { client_id, client_id_, callback } from '@/config/api'
import EmailAuth from '@/components/EmailAuth.vue'

export default {
  name: 'LoginView',
  components: {
    EmailAuth
  },
  setup() {
    const router = useRouter()
    const store = useStore()

    // Handle Google Sign-in
    const handleGoogleSignIn = async (response) => {
      try {
        if (response && response.credential) {
          const idToken = response.credential
          await store.dispatch('loginWithGoogle', idToken)

          router.push('/')
        } else {
          // No credential received
        }
      } catch (error) {
        // Error handled silently
      }
    }

    const handleSpotifySignIn = () => {
      try {
        const authEndpoint = 'https://accounts.spotify.com/authorize'
        const responseType = 'code'
        const scope = 'user-read-private user-read-email'

        const authUrl = new URL(authEndpoint)
        authUrl.searchParams.append('client_id', client_id_)
        authUrl.searchParams.append('response_type', responseType)
        authUrl.searchParams.append('redirect_uri', callback)
        authUrl.searchParams.append('scope', scope)

        window.location.href = authUrl.toString()
      } catch (error) {
        // Error handled silently
      }
    }

    onMounted(() => {
      if (store.getters.isAuthenticated) {
        router.push('/')
        return
      }

      const script = document.createElement('script')
      script.src = 'https://accounts.google.com/gsi/client'
      script.async = true
      script.defer = true
      script.onload = () => {
        if (window.google) {
          // Completely reset Google Identity Services state
          try {
            google.accounts.id.cancel()
            google.accounts.id.disableAutoSelect()
          } catch (e) {
            // Ignore if no session to cancel
          }

          // Initialize with working configuration (revert to stable settings)
          google.accounts.id.initialize({
            client_id: client_id,
            callback: handleGoogleSignIn,
            auto_select: false,
            cancel_on_tap_outside: true,
            use_fedcm_for_prompt: false,
            itp_support: false
          })

          // Immediately disable auto-select before rendering
          google.accounts.id.disableAutoSelect()

          // Use a more isolated approach - render in an iframe-like manner
          const buttonContainer = document.getElementById('googleSignInButton')

          // Clear any existing content
          buttonContainer.innerHTML = ''

          // Render button with medium size to prevent email display
          google.accounts.id.renderButton(buttonContainer, {
            theme: 'outline',
            size: 'medium',
            type: 'standard',
            shape: 'pill',
            text: 'signin_with',
            logo_alignment: 'left',
            width: '100%',
            locale: 'en_US'
          })

          // Set up simple click forwarding (revert to working approach)
          setTimeout(() => {
            const customOverlay = document.querySelector('.custom-google-button-overlay')
            if (customOverlay) {
              customOverlay.addEventListener('click', () => {
                // Find and click the actual Google button
                const googleButton = buttonContainer.querySelector('div[role="button"], button, iframe')
                if (googleButton) {
                  googleButton.click()
                }
              })
            }
          }, 200)

          // Apply targeted safeguards to prevent email display without breaking auth
          const enforceButtonAppearance = () => {
            google.accounts.id.disableAutoSelect()

            // Target the button content specifically to prevent email display
            const buttonElement = document.getElementById('googleSignInButton')
            if (buttonElement) {
              // Find all text nodes and spans that might contain email
              const textElements = buttonElement.querySelectorAll('span, div')
              textElements.forEach(element => {
                const text = element.textContent || element.innerText
                // If text contains @ symbol (email), replace with standard text
                if (text && text.includes('@')) {
                  element.textContent = 'Sign in with Google'
                  element.innerText = 'Sign in with Google'
                }
              })

              // Also check for any data attributes that might contain user info
              const allElements = buttonElement.querySelectorAll('*')
              allElements.forEach(element => {
                // Remove any data attributes that might contain user info
                if (element.hasAttribute('data-email')) element.removeAttribute('data-email')
                if (element.hasAttribute('data-profile')) element.removeAttribute('data-profile')
                if (element.hasAttribute('data-name')) element.removeAttribute('data-name')
              })
            }
          }

          // Apply immediately and with intervals to catch dynamic changes
          setTimeout(enforceButtonAppearance, 50)
          setTimeout(enforceButtonAppearance, 200)
          setTimeout(enforceButtonAppearance, 500)
          setTimeout(enforceButtonAppearance, 1000)

          // Set up a mutation observer to catch any dynamic content changes
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (mutation.type === 'childList' || mutation.type === 'characterData') {
                enforceButtonAppearance()
              }
            })
          })

          // Start observing the button container for changes
          const observerTarget = document.getElementById('googleSignInButton')
          if (observerTarget) {
            observer.observe(observerTarget, {
              childList: true,
              subtree: true,
              characterData: true,
              attributes: true,
              attributeFilter: ['data-email', 'data-profile', 'data-name']
            })
          }
        }
      }
      document.body.appendChild(script)

      return () => {
        document.body.removeChild(script)
      }
    })

    return {
      handleGoogleSignIn,
      handleSpotifySignIn
    }
  }
}
</script>

<style scoped>
/* Custom Google Button Wrapper Styles */
.custom-google-button-wrapper {
  position: relative;
  min-height: 40px;
}

.custom-google-button-overlay {
  position: relative;
  z-index: 10;
  width: 100%;
  height: 40px;
  background: #ffffff;
  border: 1px solid #dadce0;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.custom-google-button-overlay:hover {
  background: #f8f9fa;
  border-color: #c1c7cd;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.custom-google-button-overlay:active {
  background: #f1f3f4;
  border-color: #9aa0a6;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.custom-button-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  padding: 0 20px;
}

.google-logo {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.button-text {
  font-size: 16px;
  font-weight: 500;
  color: #3c4043;
  line-height: 1;
  white-space: nowrap;
}

.hidden-google-button {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  pointer-events: none;
  z-index: 1;
}

/* Ensure the hidden Google button is completely invisible */
.hidden-google-button * {
  opacity: 0 !important;
  visibility: hidden !important;
  pointer-events: none !important;
}

/* Mobile responsive adjustments */
@media (max-width: 640px) {
  .custom-google-button-wrapper {
    min-height: 40px;
  }

  .custom-google-button-overlay {
    height: 40px;
  }

  .custom-button-content {
    gap: 12px;
    padding: 0 16px;
  }

  .google-logo {
    width: 18px;
    height: 18px;
  }

  .button-text {
    font-size: 14px;
  }
}

/* Mobile viewport fixes */
@media (max-width: 640px) {
  .h-screen {
    height: 100vh !important;
    height: 100dvh !important; /* Dynamic viewport height for mobile */
    min-height: 100vh !important;
    min-height: 100dvh !important;
  }

  .fixed.inset-0 {
    width: 100vw !important;
    height: 100vh !important;
    height: 100dvh !important;
    left: 0 !important;
    top: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
  }
}
#googleSignInButton:focus,
#googleSignInButton:focus-visible,
#googleSignInButton div,
#googleSignInButton div:focus,
#googleSignInButton div:focus-visible,
#googleSignInButton iframe,
#googleSignInButton iframe:focus,
#googleSignInButton iframe:focus-visible {
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}

#googleSignInButton::-moz-focus-inner,
#googleSignInButton div::-moz-focus-inner,
#googleSignInButton iframe::-moz-focus-inner {
  border: 0 !important;
  padding: 0;
}

#googleSignInButton,
#googleSignInButton div,
#googleSignInButton iframe {
  -webkit-tap-highlight-color: transparent !important;
}

#googleSignInButton {
  min-height: 62px !important;
  border-radius: 9999px !important;
}

#googleSignInButton div,
#googleSignInButton > div,
#googleSignInButton > div > div,
#googleSignInButton > div > iframe {
  min-height: 62px !important;
  height: 62px !important;
  border: none !important;
  padding: 0 24px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

#googleSignInButton iframe,
#googleSignInButton button {
  min-height: 62px !important;
  height: 62px !important;
}

#googleSignInButton * {
  border: none !important;
  box-shadow: none !important;
}

#googleSignInButton button,
#googleSignInButton button div,
#googleSignInButton button span,
#googleSignInButton iframe,
#googleSignInButton iframe html,
#googleSignInButton iframe body,
#googleSignInButton iframe div {
  border: none !important;
  box-shadow: none !important;
  background-image: none !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  min-height: 62px !important;
  height: 62px !important;
}

#googleSignInButton > div > iframe {
  transform: scale(1.1) !important;
}

/* Additional safeguards to prevent email display in button */
#googleSignInButton [data-email],
#googleSignInButton [data-profile],
#googleSignInButton [data-name],
#googleSignInButton .personalized-content,
#googleSignInButton .user-info,
#googleSignInButton .email-display {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

/* Hide any text that contains @ symbol (email addresses) */
#googleSignInButton span:not(:empty),
#googleSignInButton div:not(:empty) {
  font-family: 'Roboto', sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #3c4043 !important;
}

/* Force hide elements containing email patterns */
#googleSignInButton *[title*="@"],
#googleSignInButton *[aria-label*="@"],
#googleSignInButton *[alt*="@"] {
  display: none !important;
  visibility: hidden !important;
  opacity: 0 !important;
}

/* Force standard button text display */
#googleSignInButton button span,
#googleSignInButton iframe span,
#googleSignInButton div span {
  font-family: 'Roboto', sans-serif !important;
  font-size: 16px !important;
  font-weight: 500 !important;
  color: #3c4043 !important;
}

/* Prevent any dynamic content injection */
#googleSignInButton::before,
#googleSignInButton::after,
#googleSignInButton *::before,
#googleSignInButton *::after {
  content: none !important;
}

.flex.justify-center.mb-4 {
  margin-bottom: 1rem !important;
  padding-bottom: 0.5rem !important;
}
</style>
